import { createUUID } from "@/utils/general";

export default {
  props: {
    cid: {
    }
  },

  data() {
    return {
      UUID: createUUID()
    }
  },

  beforeMount() {
    if (this.cid) this.UUID = this.cid;
  }
}